export default __webpack_public_path__ + "static/media/logo.ab4c2efc.svg";